const firebaseConfig = {
    apiKey: "AIzaSyDdtx83k9JfSIs5ondcqXow-AYtBrWvwBw",
    authDomain: "electro-shop-mern.firebaseapp.com",
    projectId: "electro-shop-mern",
    storageBucket: "electro-shop-mern.appspot.com",
    messagingSenderId: "1071170029786",
    appId: "1:1071170029786:web:e37a6b4045f7d1d3e6fde3"
};

export default firebaseConfig;